import { GetStaticPaths, GetStaticProps } from "next";
import { useRouter } from "next/router";
import { Fragment, VFC } from "react";
import { PageHeader, SEO } from "~/components";
import { useTranslation } from "~/hooks";
import { Article } from "~/layouts";
import { Blog, fetchAllBlog, fetchBlogById } from "~/lib/server/microcms";

type Props = {
  post: Blog;
};

export const getStaticProps: GetStaticProps<Props> = async (ctx) => {
  const { id } = ctx.params as {
    id: string;
  };
  const post = await fetchBlogById(id);
  if (!post) {
    return {
      notFound: true,
      revalidate: 60
    };
  }
  return {
    props: {
      post
    },
    revalidate: 60
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  const posts = await fetchAllBlog();
  return {
    paths: posts.contents.map((item) => `/blog/article/${item.id}`),
    fallback: true
  };
};

const BlogArticlePage: VFC<Props> = ({ post }) => {
  const { dic } = useTranslation();
  const { isFallback } = useRouter();
  return !isFallback ? (
    <Article>
      <SEO pageName={post.title} path={`/blog/article/${post.id}`} />
      <PageHeader
        labelText="Blog"
        headingText={post.title}
        crumbs={[
          {
            label: dic.homepage,
            path: "/"
          },
          {
            label: dic.navigation.blog,
            path: "/blog"
          },
          {
            label: post.title
          }
        ]}
      />
      <Article.Section>
        {post.mainImage?.url && (
          <Article.Image source={post.mainImage.url} alt={post.title} />
        )}
        <Article.Details
          dateString={post.publishedAt}
          bodyHtml={post.content}
        />
      </Article.Section>
    </Article>
  ) : (
    <Fragment />
  );
};

export default BlogArticlePage;
